// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"193af79d","820":"2169b66c"}[chunkId] + ".chunk.js";
};